import classNames from 'classnames';
import { FunctionComponent, PropsWithChildren } from 'react';
import { PageSectionProps } from './PageSectionProps';

export const PageSection: FunctionComponent<PropsWithChildren<PageSectionProps>> = ({
  title,
  subtitle,
  accessory,
  children
}) => {
  return (
    <div className="pb-10">
      <div className="items-start justify-between h-stack">
        <div className={classNames(title || subtitle ? 'pb-6' : undefined)}>
          {title ? <h2 className="text-xl font-bold tracking-wider">{title}</h2> : undefined}
          {subtitle ? <h3 className="text-sm text-text-secondary">{subtitle}</h3> : undefined}
        </div>
        {accessory ? accessory : undefined}
      </div>
      {children}
    </div>
  );
};
